import { useState } from "react";
import { Select } from "semantic-ui-react";
import { PostForm } from "../PostForm";
import { BasicModal } from "../../../Shared";
import "./Navbar.scss";

export function Navbar(props) {
  const { onReload, filters, setFilters, setCurrentPage, subjectsOptions } = props;
  const [showModal, setShowModal] = useState(false);

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);

  const statusOptions = [
    { key: "", value: "", text: "Selecciona un estado" },
    { value: "0", text: "Pendientes" },
    { value: "1", text: "Aprobadas" },
    { value: "2", text: "Rechazadas" },
  ];

  const sortOptions = [
    { key: "", value: "", text: "Selecciona un orden" },
    { value: "createdAt", text: "Más recientes" },
    { value: "votes", text: "Más votadas" },
    { value: "unanswered", text: "Sin respuesta" },
  ];

  const handleChange = (e, { name, value }) => {
    const newFilters = {
      ...filters,
      [name]: value,
    };
    setFilters(newFilters);
    setCurrentPage(1);
  };

  return (
    <div className="admin-forum-navbar">
      <div className="admin-forum-navbar__filters">
        <div className="admin-forum-navbar__filters-left">
          <Select
            name="status"
            className="admin-forum-navbar__filter-select edunova-select"
            placeholder="Selecciona un estado"
            options={statusOptions}
            value={filters.status}
            onChange={handleChange}
            clearable
          />
          <Select
            name="subjectId"
            className="admin-forum-navbar__filter-select edunova-select"
            placeholder="Selecciona una asignatura"
            options={[{ key: "", value: "", text: "Selecciona una asignatura" }, ...(subjectsOptions || [])]}
            value={filters.subjectId}
            onChange={handleChange}
            clearable
          />
          <Select
            name="order"
            className="admin-forum-navbar__filter-select edunova-select"
            placeholder="Selecciona un orden"
            options={sortOptions}
            value={filters.order}
            onChange={handleChange}
            clearable
          />
        </div>
      </div>
      <BasicModal
        show={showModal}
        size="large"
        close={onOpenCloseModal}
        title="Crear publicación"
      >
        <PostForm
          onReload={onReload}
          onClose={onOpenCloseModal}
          subjectsOptions={subjectsOptions}
        />
      </BasicModal>
    </div>
  );
}
